/* Círculos de 36: la página actual en accent lleno, las otras en tinta con hover surface,
   anterior y siguiente con borde gray-300. */
.nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-3);
}
.pagina {
  --_box: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--_box);
  height: var(--_box);
  padding: 0;
  border: var(--bw-hair) solid transparent;
  border-radius: var(--r-control);
  background: transparent;
  color: var(--text-strong);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  font-variant-numeric: tabular-nums;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition:
    background var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);
}
.pagina[aria-current="page"] {
  background: var(--action-primary);
  border-color: var(--action-primary);
  color: var(--action-primary-text);
  cursor: default;
}
.pagina[data-flecha] {
  background: var(--surface-card);
  border-color: var(--border-strong);
}
@media (hover: hover) {
  .pagina:not([aria-current="page"]):not([aria-disabled="true"]):not(:disabled):hover {
    background: var(--action-quiet-hover);
  }
  .pagina[data-flecha]:not([aria-disabled="true"]):not(:disabled):hover {
    background: var(--surface-card);
    border-color: var(--border-hover);
  }
}
.pagina:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.pagina:disabled,
.pagina[aria-disabled="true"] {
  color: var(--control-disabled-text);
  border-color: var(--control-disabled-border);
  cursor: not-allowed;
}
.puntos {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  color: var(--text-subtle);
  font-size: var(--fs-xs);
}
.estado {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
@media (prefers-reduced-motion: reduce) {
  .pagina {
    transition: none;
  }
}
